export default {
  search: '查询',
  operation: '操作',
  edit: '编辑',
  submit: '提交',
  re_edit: '重新编辑',
  confirm: '确认',
  cancel: '取消',
  close: '关闭',
  open: '开启',
  drag_file_here: '将文件拖到此处，或 ',
  click_it_upload: '点击上传',
  set: '设置',
  change: '更改',
  next: '下一步',
  previous: '上一步',
  update: '更新',
  detail: '详情',
  show: '展示',
  send: '发送验证码',
  re_send: '重新发送',
  re_set: '重置',
  retry: '重试',
  view: '查看',
  clear: '清空',
  modify: '修改',
  login_out: '退出登录',
  home: '首页',
  amount: '金额',
  amount_to_receive: '到账金额',
  date: '日期',
  time: '时间',
  start_date: '开始日期',
  end_date: '结束日期',
  create_time: '创建时间',
  transaction_date: '交易日期',
  status: '状态',
  link: '链接',
  add: '添加',
  copy: '复制',
  download: '下载',
  handle: '处理',
  success: '成功',
  back: '返回',
  total: '合计',
  delete: '删除',
  create: '创建',
  email: '邮箱',
  operator: '操作人',
  tips: '提示',
  operation_time: '操作时间',
  last_operator: '最后操作人',
  proceed: '前往',
  notification: '通知',
  reason: '原因',
  transaction_country: '交易国家',
  create_payment: '创建付款',
  refund: '退款',
  complete_time: '完成时间',
  filter: '筛选',
  activity: '活动',
  select: '选择',
  selected: '已选',
  banks: '银行卡',
  view_details: '查看详情',
  time_zone: '时区',
  refresh: '刷新',
  type: '类型',
  yes: '是',
  no: '否',
  click_to_upload: '点击上传',
  action: '操作',
  cancel_withdraw: '取消提现',
  save: '保存'
}
